export default __webpack_public_path__ + "static/media/burger.65e0c867.png";